/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, Spacer, theme, FlexContainer } from "@nordcloud/gnui";
import { GroupsForResourceSortFields, SortOrder } from "~/generated/graphql";
import { TableSearchInput } from "~/components/SearchInput";
import { SortSelector } from "~/components/SortSelector";
import { useQueryState } from "~/hooks";
import { ResourceDetailsResourceGroupsQuery } from "../../types/ResourceDetailsResourceGroupsQuery";
import { ResourceDetailsResourceGroupsFiltersSidebar } from "./ResourceDetailsResourceGroupsFiltersSidebar";

const sortOptions = [
  {
    value: GroupsForResourceSortFields.Name,
    label: "Resource Group Name",
  },
  {
    value: GroupsForResourceSortFields.CreatedAt,
    label: "Date Created",
  },
  {
    value: GroupsForResourceSortFields.UpdatedAt,
    label: "Date Updated",
  },
];

export function ResourceDetailsResourceGroupsTableHeader({
  resultsCount = 0,
}: {
  resultsCount?: number;
}) {
  const { queryState, updateQueryState } =
    useQueryState<ResourceDetailsResourceGroupsQuery>();

  const handleSortDirection = (order: SortOrder) => {
    updateQueryState({
      ...queryState,
      order,
    });
  };

  const handleSortField = (field: GroupsForResourceSortFields) => {
    updateQueryState({
      ...queryState,
      field,
    });
  };

  const handlePhraseField = (field: string | undefined) => {
    updateQueryState({
      ...queryState,
      searchPhrase: field,
    });
  };

  return (
    <>
      <Box boxStyle="lightGrey" spacing="spacing04">
        <FlexContainer justifyContent="space-between">
          <SortSelector<GroupsForResourceSortFields>
            options={sortOptions}
            value={queryState.field ?? GroupsForResourceSortFields.Name}
            direction={queryState.order ?? SortOrder.Asc}
            onSelect={handleSortField}
            onSortChange={handleSortDirection}
          />
          <Spacer width={theme.spacing.spacing04} />
          <TableSearchInput<ResourceDetailsResourceGroupsQuery>
            onSubmit={handlePhraseField}
            placeholder="Type a Keyword (e.g. Resource Group Name, Group ID, Plan Name, etc.)"
          />
          <Spacer width={theme.spacing.spacing04} />
          <ResourceDetailsResourceGroupsFiltersSidebar
            resultsCount={resultsCount}
          />
        </FlexContainer>
      </Box>
    </>
  );
}
